export default __webpack_public_path__ + "static/media/7.488434c7.webp";